import { forIn, orderBy } from "lodash";

import { AlarmZoneType } from "./AlarmZoneType";
import type { IrMap } from "./IrMap";

export class AlarmZoneTypeFunctions {
    public static GetAlarmZoneTypes(): AlarmZoneType[] {
        const azt: AlarmZoneType[] = [];
        forIn(AlarmZoneType, (key) => {
            if (typeof key === "number") {
                azt.push(key as any as AlarmZoneType);
            }
        });
        return azt;
    }

    public static GetAlarmZoneTypeDictionary($translate: ng.translate.ITranslateService): IrMap<AlarmZoneType, string> {
        const dictionary = AlarmZoneTypeFunctions.GetAlarmZoneTypes().map((azt) => ({
            key: azt,
            value: $translate.instant(`Enums.AlarmZoneType.${AlarmZoneType[azt]}`),
        }));

        return dictionary;
        return orderBy(dictionary, "value");
    }
}
